
import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { motion } from "framer-motion";

interface ProfileAvatarProps {
  avatarUrl?: string;
  fullName: string;
}

const ProfileAvatar = ({ avatarUrl, fullName }: ProfileAvatarProps) => {
  // Get initials from name
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase() || 'U';
  };

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      transition={{ type: "spring", stiffness: 300, damping: 10 }}
    >
      <Avatar className="h-24 w-24 border-2 border-primary/20">
        <AvatarImage src={avatarUrl} alt={fullName} />
        <AvatarFallback className="text-xl font-bold bg-gradient-to-br from-primary/20 to-secondary/20">
          {getInitials(fullName || '')}
        </AvatarFallback>
      </Avatar>
    </motion.div>
  );
};

export default ProfileAvatar;
